/* ---------------- GLOBAL STYLES ---------------- */

export const globalStyles = {
  page: {
    padding: "24px",
    maxWidth: "520px",
    margin: "0 auto",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    minHeight: "100vh"
  },

  card: {
    background: "#ffffff",
    padding: "18px",
    borderRadius: "18px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
    border: "1px solid rgba(0,0,0,0.04)",
    marginTop: "12px"
  },

  primaryBtn: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "14px",
    border: "none",
    background: "linear-gradient(135deg, #111827, #374151)",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
    transition: "all 0.2s ease"
  },

  secondaryBtn: {
    padding: "10px 14px",
    borderRadius: "14px",
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease"
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    outline: "none",
    fontSize: "14px",
    marginBottom: "10px",
    background: "#fff"
  },

  chipBtn: {
    padding: "8px 14px",
    borderRadius: "999px",
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer",
    fontSize: "13px",
    transition: "all 0.2s ease"
  },

  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px"
  },

  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(10px)",
    borderBottom: "1px solid #eee",
    position: "sticky",
    top: 0,
    zIndex: 100
  },

  logo: {
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 0.3
  },

  tabs: {
    display: "flex",
    gap: 24
  },

  tab: {
    position: "relative",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
  },

  underline: {
    position: "absolute",
    bottom: -2,
    left: 0,
    width: "100%",
    height: 2,
    background: "#111",
    transformOrigin: "left",
    transition: "transform 0.2s ease"
  }
};

/* ---------------- COMPONENT SPECIFIC STYLES ---------------- */

export const homeStyles = {
  page: {
    fontFamily: "'Inter', Arial, sans-serif",
  },

  hero: {
    background: "#fff7ed",
    borderBottom: "1px solid #fed7aa",
    padding: "52px 20px",
  },

  heroCopy: {
    maxWidth: 780,
    margin: "0 auto",
  },

  heroLogo: {
    display: "block",
    width: 96,
    height: "auto",
    marginBottom: 20
  },

  heroTitle: {
    margin: 0,
    fontSize: 40,
    lineHeight: 1.05,
    fontWeight: 800,
    color: "#1f2937",
    letterSpacing: 0
  },

  heroSubtitle: {
    marginTop: 18,
    marginBottom: 26,
    maxWidth: 520,
    fontSize: 20,
    lineHeight: 1.55,
    color: "#475569"
  },

  heroButton: {
    padding: "14px 28px",
    borderRadius: 999,
    border: "none",
    background: "linear-gradient(135deg, #ff7a59, #f25f4c)",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "inherit",
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(242,95,76,0.30)",
    transition: "transform 0.18s ease, box-shadow 0.18s ease"
  },

  heroVisual: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 280
  },

  plate: {
    width: "min(100%, 320px)",
    aspectRatio: "1",
    borderRadius: "50%",
    background: "#ffffff",
    border: "18px solid #ffedd5",
    boxShadow: "0 24px 54px rgba(124, 45, 18, 0.14)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
    position: "relative"
  },

  foodBite: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 112,
    minHeight: 48,
    padding: "0 14px",
    borderRadius: 999,
    color: "#1f2937",
    fontSize: 15,
    fontWeight: 700,
    background: "#dcfce7",
    border: "1px solid #bbf7d0",
    boxShadow: "0 8px 18px rgba(21, 128, 61, 0.1)"
  },

  label: {
    marginTop: 18,
    marginBottom: 8,
    fontSize: 14,
    fontWeight: 600,
    color: "#334155"
  },

  welcomeTitle: {
    marginTop: 0,
    marginBottom: 6,
    fontSize: 28,
    color: "#0f172a"
  },

  welcomeSubtitle: {
    marginTop: 0,
    marginBottom: 24,
    fontSize: 16,
    color: "#475569",
    lineHeight: 1.5
  },

  sectionTitle: {
    marginTop: 0,
    marginBottom: 22,
    fontSize: 20,
    fontWeight: 700,
    color: "#0f172a"
  },

  chip: {
    padding: "8px 14px",
    borderRadius: 20,
    border: "none",
    cursor: "pointer",
    fontSize: 15,
    fontWeight: 500,
    transition: "all 0.2s ease"
  },

  chatBox: {
    marginTop: 14,
    background: "#f7fbff",
    border: "1px solid #d9e8ff",
    borderRadius: 16,
    padding: 14
  },

  chatPrompt: {
    marginBottom: 8,
    fontSize: 14,
    color: "#334155"
  },

  chatInput: {
    width: "100%",
    minHeight: 72,
    resize: "vertical",
    padding: 12,
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    fontSize: 14,
    lineHeight: 1.5,
    fontFamily: "inherit",
    color: "#0f172a",
    outline: "none",
    boxShadow: "inset 0 1px 2px rgba(15,23,42,0.05)"
  },

  concernInput: {
    width: "100%",
    minHeight: 82,
    resize: "vertical",
    padding: 12,
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    fontSize: 14,
    lineHeight: 1.6,
    fontFamily: "inherit",
    color: "#0f172a",
    outline: "none",
    background: "#fff",
    marginTop: 4
  },

  input: {
    flex: 1,
    minWidth: 0,
    padding: "12px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    outline: "none",
    fontSize: "14px",
    fontFamily: "inherit",
    color: "#0f172a",
    background: "#fff"
  },

  helperText: {
    marginTop: 6,
    marginBottom: 0,
    fontSize: 12,
    color: "#64748b"
  },

  errorText: {
    marginTop: 6,
    marginBottom: 0,
    fontSize: 12,
    color: "#dc2626"
  },

  allergyInputRow: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    marginTop: 10
  },

  addAllergyBtn: {
    padding: "12px 16px",
    borderRadius: 12,
    border: "1px solid #d1d5db",
    background: "#fff",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "inherit",
    whiteSpace: "nowrap"
  },

  selectedAllergies: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 10
  },

  selectedAllergyChip: {
    padding: "8px 12px",
    borderRadius: 999,
    border: "1px solid #dbeafe",
    background: "#eff6ff",
    color: "#1d4ed8",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 500
  }
};

export const heroStyles = {
  heroContainer: {
    position: "relative",
    minHeight: "110px",
    borderRadius: "18px",
    overflow: "hidden",
    background: "linear-gradient(135deg, #50a7ff, #8bc34a)",
    color: "#fff",
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "18px 20px"
  },

  topBar: {
    position: "absolute",
    top: 16,
    left: 16,
    right: 16,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 3,
    gap: 16,
    flexWrap: "wrap"
  },

  logoImg: {
    height: "22px",
    maxWidth: "120px",
    width: "auto"
  },

  navButtons: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    alignItems: "center",
    justifyContent: "center"
  },

  navBtn: {
    minWidth: "110px",
    padding: "12px 22px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.35)",
    background: "rgba(255,255,255,0.18)",
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "center",
    transition: "all 0.2s ease"
  },

  navBtnPrimary: {
    minWidth: "120px",
    padding: "12px 24px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.35)",
    background: "#fff",
    color: "#111",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    transition: "all 0.2s ease"
  },

  brandMark: {
    position: "absolute",
    inset: 0,
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "96px",
    fontWeight: 900,
    color: "rgba(255,255,255,0.08)",
    textTransform: "uppercase",
    letterSpacing: "12px",
    pointerEvents: "none",
    zIndex: 1
  },

  heroText: {
    position: "relative",
    zIndex: 2,
    display: "none",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: 12,
    maxWidth: "700px",
    padding: "0 16px"
  },

  bigLogo: {
    fontSize: "36px",
    fontWeight: 900,
    lineHeight: 1,
    letterSpacing: "-1px",
    textShadow: "2px 2px 10px rgba(0,0,0,0.35)"
  },

  tagline: {
    fontSize: "18px",
    opacity: 0.92,
    maxWidth: "640px"
  }
};

export const resultStyles = {
  page: {
    maxWidth: 920,
    margin: "0 auto",
    paddingBottom: 40,
    position: "relative",
    zIndex: 1
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 18
  },

  headerActions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap"
  },

  pageTitle: {
    margin: 0,
    fontSize: 32,
    fontWeight: 800,
    color: "#0f172a"
  },

  navButton: {
    padding: "10px 16px",
    borderRadius: 999,
    border: "1px solid #f0d9d1",
    background: "rgba(255,255,255,0.85)",
    color: "#7c3d2e",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    transition: "all 0.2s ease"
  },

  navButtonSecondary: {
    padding: "10px 16px",
    borderRadius: 999,
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    transition: "all 0.2s ease"
  },

  listCard: {
    background: "rgba(255,255,255,0.88)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
    border: "1px solid rgba(255,255,255,0.72)",
    backdropFilter: "blur(10px)",
    marginTop: 18
  },

  featuredCard: {
    background: "linear-gradient(145deg, rgba(255,244,240,0.96), rgba(255,255,255,0.92))",
    border: "1px solid rgba(255,194,179,0.75)"
  },

  sectionHeader: {
    marginBottom: 16
  },

  sectionBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "7px 12px",
    borderRadius: 999,
    background: "#f25f4c",
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.2
  },

  secondaryBadge: {
    background: "#f59e0b"
  },

  sectionDescription: {
    marginTop: 10,
    marginBottom: 0,
    color: "#475569",
    lineHeight: 1.6
  },

  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    padding: "16px 18px",
    borderRadius: 16,
    background: "rgba(255,255,255,0.9)",
    border: "1px solid #f1f5f9",
    marginTop: 10
  },

  primaryListItem: {
    background: "linear-gradient(145deg, rgba(255,255,255,0.96), rgba(255,246,243,0.96))",
    border: "1px solid #ffd3c7"
  },

  listItemTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#0f172a"
  },

  listItemTag: {
    padding: "6px 10px",
    borderRadius: 999,
    background: "#fee2e2",
    color: "#b42318",
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: "nowrap"
  },

  listItemTagMuted: {
    padding: "6px 10px",
    borderRadius: 999,
    background: "#f8fafc",
    color: "#64748b",
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: "nowrap"
  },

  messageCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 150,
    marginTop: 20
  },

  message: {
    margin: 0,
    maxWidth: 520,
    textAlign: "center",
    fontSize: 24,
    lineHeight: 1.5,
    fontWeight: 700,
    color: "#0f172a"
  },

  selectionCard: {
    background: "rgba(255,255,255,0.88)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
    border: "1px solid rgba(255,255,255,0.72)",
    backdropFilter: "blur(10px)",
    marginTop: 8
  },

  selectionTitle: {
    marginTop: 0,
    marginBottom: 18,
    fontSize: 20,
    fontWeight: 700,
    color: "#0f172a"
  },

  selectionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: 14
  },

  selectionItem: {
    padding: "14px 16px",
    borderRadius: 16,
    background: "rgba(248,250,252,0.92)",
    border: "1px solid #e2e8f0"
  },

  subtle: {
    marginTop: 0,
    marginBottom: 6,
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: 0.4
  },

  selectionPillRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
    marginTop: 18
  },

  selectionPillLabel: {
    fontSize: 13,
    fontWeight: 700,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: 0.4
  },

  selectionPill: {
    padding: "7px 12px",
    borderRadius: 999,
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: 13,
    fontWeight: 600
  },

  selectionPillMuted: {
    padding: "7px 12px",
    borderRadius: 999,
    background: "#f8fafc",
    color: "#64748b",
    fontSize: 13,
    fontWeight: 600
  },

  faqCard: {
    background: "rgba(255,255,255,0.88)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
    border: "1px solid rgba(255,255,255,0.72)",
    backdropFilter: "blur(10px)",
    marginTop: 20
  },

  faqTitle: {
    marginTop: 0,
    marginBottom: 18,
    fontSize: 22,
    fontWeight: 800,
    color: "#0f172a"
  },

  faqItem: {
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: "1px solid #e2e8f0"
  },

  faqQuestion: {
    marginTop: 0,
    marginBottom: 8,
    fontSize: 17,
    color: "#0f172a"
  },

  faqAnswer: {
    margin: 0,
    color: "#475569",
    lineHeight: 1.7
  }
};
